module.exports = __webpack_public_path__ + "static/img/active2.48e07b5f.png";